import React, { useContext } from 'react';
import CurrentPageButton from './CurrentPageButton';
import DestinationPageButton from './DestinationPageButton';
import PaginationContext from '../data/PaginationContext';

var PageButton = function PageButton(props) {
  var pageNumber = props.pageNumber;

  var _useContext = useContext(PaginationContext),
      currentPage = _useContext.page;

  return currentPage === pageNumber ? /*#__PURE__*/React.createElement(CurrentPageButton, props) : /*#__PURE__*/React.createElement(DestinationPageButton, props);
};

export default PageButton;